import * as types from '../mutation-types'

const state = {
  lines: JSON.parse(localStorage.getItem('inventory_lines')) || {},
  statuses: JSON.parse(localStorage.getItem('inventory_statuses')) || {}
}

const mutations = {
  [types.INVENTORY_RESET_VALUES] (state) {
    let defaultValues = getDefaultValues()
    state.lines = defaultValues.lines
    state.statuses = defaultValues.statuses
    localStorage.removeItem('inventory_lines')
    localStorage.removeItem('inventory_statuses')
  },
  [types.INVENTORY_SET_ITEMS] (state, types) {
    state.types = types
    localStorage.setItem('inventory_items', JSON.stringify(types))
  },
  [types.INVENTORY_SET_LINES] (state, lines) {
    state.lines[lines.accountCode] = lines.data
    localStorage.setItem('inventory_lines', JSON.stringify(state.lines))
  },
  [types.INVENTORY_SET_STATUSES] (state, statuses) {
    state.statuses[statuses.accountCode] = statuses.data
    localStorage.setItem('inventory_statuses', JSON.stringify(state.statuses))
  }
}

function getDefaultValues () {
  return {
    lines: {},
    statuses: {}
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/inventory.js